import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Table, Image, Pagination, Modal,Alert } from 'react-bootstrap';
import { Routes, Route, useNavigate, Link } from 'react-router-dom';
import DashboardHeader from './DashboardHeader';
import NotificationList from './NotificationList';
import EventSlideList from './EventSlideList';
import ContactInfoManager from './ContactInfoManager';
import TestimonialList from './TestimonialList';
import Footer from './Footer';
import Imagedonatelogo from '../images/header1.jpg';
import Imagedonatelogosign from '../images/Signature-Of-srisailam.png'
import { saveAs } from 'file-saver'; // For downloading PDF
import html2canvas from 'html2canvas'; // For converting modal to image
import jsPDF from 'jspdf'; // For generating PDF


// Base URL from .env
const API_URL = process.env.REACT_APP_API_URL;
interface Testimonial {
  id: number;
  name: string;
  text: string;
  created_at: string;
  updated_at: string;
}
// डेटा के लिए इंटरफेस डिफाइन करें
interface Member {
  id: number;
  memberId: string;
  fullName: string;
  mobile: string;
  email: string;
  aadhar: string;
  referenceBy: string | null;
  gender: string;
  dateOfBirth: string;
  fathersName: string;
  state: string;
  city: string;
  pinCode: string;
  address: string;
  nationality: string;
  qualification: string;
  areaOfOperation: string;
  experience: string | null;
  briefAboutYourself: string;
  photoUrl: string | null;
  resumeUrl: string | null;
}

interface Volunteer {
  id: number;
  volunteerId: string;
  fullName: string;
  mobile: string;
  email: string;
  aadhar: string;
  gender: string;
  dateOfBirth: string;
  state: string;
  city: string;
  pinCode: string;
  address: string;
  skills: string[];
  otherSkill: string;
  availability: string;
  volunteeringArea: string;
  previousExperience: string;
  experienceDetails: string;
  photoUrl: string | null;
}

export interface Donation {
  id: number;
  fullName: string;
  mobile: string;
  email: string;
  dateOfBirth: string;
  country: string;
  state: string;
  city: string;
  pinCode: string;
  address: string;
  panNo: string;
  amount: number;
  paymentMethod: string;
  message?: string;
  photoUrl?: string | null;
  createdAt?: string;
  receiptNo?: string;
  preARN?: string;
  certificateNo?: string;
}

interface Blog {
  id: number;
  title: string;
  description: string;
  imageUrl: string | null;
}
interface EventSlide {
  id: number;
  title: string;
  description: string;
  imageUrl: string | null;
}

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
    }
  }, [navigate]);

  return (
    <>
      <DashboardHeader />
      <section className="dashboard-section py-5 mt-5">
        <Container>
          <Routes>
            <Route path="/" element={<DashboardHome />} />
            <Route path="/members" element={<MemberList />} />
            <Route path="/donations" element={<DonationList />} />
            <Route path="/volunteers" element={<VolunteerList />} />
            <Route path="/add-blog" element={<AddBlog />} />
            <Route path="/blog-list" element={<BlogList />} />
            <Route path="/notifications" element={<NotificationList />} /> {/* New Route */}
  <Route path="/event-slides" element={<EventSlideList />} /> {/* New Route */}
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/contact-info" element={<ContactInfoManager />} />
            <Route path="/testimonials" element={<TestimonialList />} />
          </Routes>
        </Container>
      </section>
      <Footer />
    </>
  );
};

// डैशबोर्ड होम
const DashboardHome: React.FC = () => {
  const [members, setMembers] = useState<Member[]>([]);
  const [volunteers, setVolunteers] = useState<Volunteer[]>([]);
  const [donations, setDonations] = useState<Donation[]>([]);
  const [blogs, setBlogs] = useState<Blog[]>([]);
  const [notifications, setNotifications] = useState<Notification[]>([]); // Fixed variable name
  const [eventSlides, setEventSlides] = useState<EventSlide[]>([]);
  const [testimonials, setTestimonials] = useState<Testimonial[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        const membersRes = await fetch(`${API_URL}/api/members`, { headers });
        if (!membersRes.ok) throw new Error('Failed to fetch members');
        const membersData: Member[] = await membersRes.json();
        setMembers(membersData);

        const volunteersRes = await fetch(`${API_URL}/api/volunteers`, { headers });
        if (!volunteersRes.ok) throw new Error('Failed to fetch volunteers');
        const volunteersData: Volunteer[] = await volunteersRes.json();
        setVolunteers(volunteersData);

        const donationsRes = await fetch(`${API_URL}/api/donations`, { headers });
        if (!donationsRes.ok) throw new Error('Failed to fetch donations');
        const donationsData: Donation[] = await donationsRes.json();
        setDonations(donationsData);

        const blogsRes = await fetch(`${API_URL}/api/blogs`, { headers });
        if (!blogsRes.ok) throw new Error('Failed to fetch blogs');
        const blogsData: Blog[] = await blogsRes.json();
        setBlogs(blogsData);
        // Fetch notifications
        const notificationsRes = await fetch(`${API_URL}/api/notifications`, { headers });
        if (!notificationsRes.ok) throw new Error('Failed to fetch notifications');
        const notificationsData: Notification[] = await notificationsRes.json();
        setNotifications(notificationsData);

        // Fetch event slides
        const eventSlidesRes = await fetch(`${API_URL}/api/event-slides`, { headers });
        if (!eventSlidesRes.ok) throw new Error('Failed to fetch event slides');
        const eventSlidesData: EventSlide[] = await eventSlidesRes.json();
        setEventSlides(eventSlidesData);
        //testi
      const testimonialsRes = await fetch(`${API_URL}/api/testimonials`, { headers });
        if (!testimonialsRes.ok) throw new Error('Failed to fetch testimonials');
        const testimonialsData: Testimonial[] = await testimonialsRes.json();
        setTestimonials(testimonialsData);
        
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <h2 className="dashboard-title text-center mb-5">Admin Dashboard</h2>
      <Row>
        <Col md={3} className="mb-4">
          <Card className="dashboard-card">
            <Card.Body>
              <Card.Title className="dashboard-card-title">Members</Card.Title>
              <Card.Text className="dashboard-card-text">{members.length} Total Members</Card.Text>
              <Link to="/dashboard/members">
                <Button variant="primary" className="dashboard-btn">View List</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} className="mb-4">
          <Card className="dashboard-card">
            <Card.Body>
              <Card.Title className="dashboard-card-title">Volunteers</Card.Title>
              <Card.Text className="dashboard-card-text">{volunteers.length} Total Volunteers</Card.Text>
              <Link to="/dashboard/volunteers">
                <Button variant="primary" className="dashboard-btn">View List</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} className="mb-4">
          <Card className="dashboard-card">
            <Card.Body>
              <Card.Title className="dashboard-card-title">Donations</Card.Title>
              <Card.Text className="dashboard-card-text">{donations.length} Total Donations</Card.Text>
              <Link to="/dashboard/donations">
                <Button variant="primary" className="dashboard-btn">View List</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
      <Col md={3} className="mb-4">
          <Card className="dashboard-card">
            <Card.Body>
              <Card.Title className="dashboard-card-title">Testimonials</Card.Title>
              <Card.Text className="dashboard-card-text">{testimonials.length} Total Testimonials</Card.Text>
              <Link to="/dashboard/testimonials">
                <Button variant="primary" className="dashboard-btn">Manage Testimonials</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} className="mb-4">
          <Card className="dashboard-card">
            <Card.Body>
              <Card.Title className="dashboard-card-title">Add Blogs</Card.Title>
              <Card.Text className="dashboard-card-text">{blogs.length} Total Blogs</Card.Text>
              <Link to="/dashboard/add-blog">
                <Button variant="primary" className="dashboard-btn">Add Blog</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} className="mb-4">
  <Card className="dashboard-card">
    <Card.Body>
      <Card.Title className="dashboard-card-title">View Blog List</Card.Title>
      <Card.Text className="dashboard-card-text">{blogs.length} Total Blogs</Card.Text>
      <Link to="/dashboard/blog-list">
        <Button variant="primary" className="dashboard-btn">View List</Button>
      </Link>
    </Card.Body>
  </Card>
</Col>
<Col md={3} className="mb-4">
          <Card className="dashboard-card">
            <Card.Body>
              <Card.Title className="dashboard-card-title">Notifications</Card.Title>
              <Card.Text className="dashboard-card-text">{notifications.length} Total Notifications</Card.Text>
              <Link to="/dashboard/notifications">
                <Button variant="primary" className="dashboard-btn">Manage Notifications</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} className="mb-4">
          <Card className="dashboard-card">
            <Card.Body>
              <Card.Title className="dashboard-card-title">Event Slides</Card.Title>
              <Card.Text className="dashboard-card-text">{eventSlides.length} Total Slides</Card.Text>
              <Link to="/dashboard/event-slides">
                <Button variant="primary" className="dashboard-btn">Manage Slides</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} className="mb-4">
  <Card className="dashboard-card">
    <Card.Body>
      <Card.Title className="dashboard-card-title">Contact Info</Card.Title>
      <Card.Text className="dashboard-card-text">Manage Contact Details</Card.Text>
      <Link to="/dashboard/contact-info">
        <Button variant="primary" className="dashboard-btn">Manage</Button>
      </Link>
    </Card.Body>
  </Card>
</Col>
      </Row>
    </>
  );
};

// मेंबर लिस्ट
const MemberList: React.FC = () => {
  const [members, setMembers] = useState<Member[]>([]);
  const [editMember, setEditMember] = useState<Member | null>(null);
  const [editPhoto, setEditPhoto] = useState<File | null>(null);
  const [editResume, setEditResume] = useState<File | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState<Member | null>(null);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const recordsPerPage = 10;

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_URL}/api/members`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error('Failed to fetch members');
        const data: Member[] = await res.json();
        setMembers(data);
      } catch (err) {
        console.error('Error fetching members:', err);
      }
    };
    fetchMembers();
  }, []);

  const handleDelete = async (id: number) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/api/members/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error('Failed to delete member');
      setMembers(members.filter((member) => member.id !== id));
    } catch (err) {
      console.error('Error deleting member:', err);
    }
  };

  const handleEdit = (member: Member) => {
    setEditMember(member);
    setEditPhoto(null);
    setEditResume(null);
    setShowEditModal(true);
  };

  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!editMember) return;

    const formDataToSend = new FormData();
    Object.entries(editMember).forEach(([key, value]) => {
      if (value !== null && key !== 'id' && key !== 'photoUrl' && key !== 'resumeUrl') {
        formDataToSend.append(key, value.toString());
      }
    });
    if (editPhoto) formDataToSend.append('photo', editPhoto);
    if (editResume) formDataToSend.append('resume', editResume);
    if (!editPhoto && editMember.photoUrl) formDataToSend.append('photoUrl', editMember.photoUrl);
    if (!editResume && editMember.resumeUrl) formDataToSend.append('resumeUrl', editMember.resumeUrl);

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/api/members/${editMember.id}`, {
        method: 'PUT',
        headers: { Authorization: `Bearer ${token}` },
        body: formDataToSend,
      });

      if (res.ok) {
        const updatedMember = await res.json();
        setMembers(
          members.map((member) =>
            member.id === editMember.id
              ? { ...member, ...editMember, photoUrl: updatedMember.photoUrl || member.photoUrl, resumeUrl: updatedMember.resumeUrl || member.resumeUrl }
              : member
          )
        );
        setEditMember(null);
        setEditPhoto(null);
        setEditResume(null);
        setShowEditModal(false);
      } else {
        console.error('Failed to update member:', await res.json());
      }
    } catch (err) {
      console.error('Error updating member:', err);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    if (editMember) {
      setEditMember({ ...editMember, [e.target.name]: e.target.value });
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, field: 'photo' | 'resume') => {
    if (e.target.files && e.target.files.length > 0) {
      if (field === 'photo') {
        setEditPhoto(e.target.files[0]);
      } else {
        setEditResume(e.target.files[0]);
      }
    }
  };

  const handleImageClick = (photoUrl: string) => {
    setSelectedImage(photoUrl);
    setShowModal(true);
  };

  const handleDeleteImage = async (id: number) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/api/members/${id}`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ photoUrl: null }),
      });

      if (res.ok) {
        setMembers(members.map((member) => (member.id === id ? { ...member, photoUrl: null } : member)));
        setShowModal(false);
      }
    } catch (err) {
      console.error('Error deleting image:', err);
    }
  };

  const handleViewDetails = (member: Member) => {
    setSelectedMember(member);
    setShowDetailsModal(true);
  };

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = members.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(members.length / recordsPerPage);

  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  return (
    <>
      <h2 className="dashboard-title text-center mb-5">Member List</h2>
      <Table striped bordered hover responsive className="modern-table">
        <thead>
          <tr>
            <th>Photo</th>
            
            <th>Full Name</th>
            <th>Mobile</th>
            <th>Email</th>
            <th>Address</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentRecords.map((member) => (
            <tr key={member.id}>
              <td>
                {member.photoUrl ? (
                  <Image
                    src={`${API_URL}${member.photoUrl}`}
                    alt="Member Photo"
                    width={50}
                    height={50}
                    rounded
                    className="clickable-image"
                    onClick={() => handleImageClick(`${API_URL}${member.photoUrl}`)}
                  />
                ) : (
                  'No Photo'
                )}
              </td>
              
              <td>{member.fullName}</td>
              <td>{member.mobile}</td>
              <td>{member.email}</td>
              <td>{member.address}</td>
              <td className="action-buttons">
                <Button
                  variant="info"
                  size="sm"
                  className="me-2 modern-btn"
                  onClick={() => handleViewDetails(member)}
                >
                  <i className="fas fa-eye"></i> View Details
                </Button>
                <Button
                  variant="warning"
                  size="sm"
                  className="me-2 modern-btn"
                  onClick={() => handleEdit(member)}
                >
                  <i className="fas fa-edit"></i> Edit
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  className="modern-btn"
                  onClick={() => handleDelete(member.id)}
                >
                  <i className="fas fa-trash-alt"></i> Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Pagination className="justify-content-center mt-4">
        {Array.from({ length: totalPages }, (_, index) => (
          <Pagination.Item
            key={index + 1}
            active={index + 1 === currentPage}
            onClick={() => paginate(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}
      </Pagination>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>View Image</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {selectedImage && <Image src={selectedImage} alt="Selected" fluid style={{ maxHeight: '400px' }} />}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => handleDeleteImage(editMember!.id)}>
            Delete Image
          </Button>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Member Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedMember && (
            <div>
             
              <p><strong>Full Name:</strong> {selectedMember.fullName}</p>
              <p><strong>Mobile:</strong> {selectedMember.mobile}</p>
              <p><strong>Email:</strong> {selectedMember.email}</p>
              <p><strong>Aadhar:</strong> {selectedMember.aadhar || 'N/A'}</p>
              <p><strong>Reference By:</strong> {selectedMember.referenceBy || 'N/A'}</p>
              <p><strong>Gender:</strong> {selectedMember.gender || 'N/A'}</p>
              <p><strong>Date of Birth:</strong> {selectedMember.dateOfBirth || 'N/A'}</p>
              <p><strong>Father's Name:</strong> {selectedMember.fathersName || 'N/A'}</p>
              <p><strong>State:</strong> {selectedMember.state || 'N/A'}</p>
              <p><strong>City:</strong> {selectedMember.city || 'N/A'}</p>
              <p><strong>Pin Code:</strong> {selectedMember.pinCode || 'N/A'}</p>
              <p><strong>Address:</strong> {selectedMember.address || 'N/A'}</p>
              <p><strong>Nationality:</strong> {selectedMember.nationality || 'N/A'}</p>
              <p><strong>Qualification:</strong> {selectedMember.qualification || 'N/A'}</p>
              <p><strong>Area of Operation:</strong> {selectedMember.areaOfOperation || 'N/A'}</p>
              <p><strong>Experience:</strong> {selectedMember.experience || 'N/A'}</p>
              <p><strong>Brief About Yourself:</strong> {selectedMember.briefAboutYourself || 'N/A'}</p>
              <p>
                <strong>Resume:</strong> {selectedMember.resumeUrl ? (
                  <a href={`${API_URL}${selectedMember.resumeUrl}`} target="_blank" rel="noopener noreferrer">
                    View Resume
                  </a>
                ) : 'No Resume'}
              </p>
              <p>
                <strong>Photo:</strong> {selectedMember.photoUrl ? (
                  <Image src={`${API_URL}${selectedMember.photoUrl}`} alt="Member Photo" width={100} height={100} rounded />
                ) : 'No Photo'}
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetailsModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {editMember && (
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Edit Member</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleUpdate}>
              <Form.Group className="mb-3">
                <Form.Label>Current Photo</Form.Label>
                <div>
                  {editMember.photoUrl ? (
                    <Image src={`${API_URL}${editMember.photoUrl}`} alt="Current Photo" width={100} height={100} rounded />
                  ) : (
                    'No Photo'
                  )}
                </div>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Upload New Photo</Form.Label>
                <Form.Control
                  type="file"
                  name="photo"
                  accept="image/*"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFileChange(e, 'photo')}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Current Resume</Form.Label>
                <div>
                  {editMember.resumeUrl ? (
                    <a href={`${API_URL}${editMember.resumeUrl}`} target="_blank" rel="noopener noreferrer">
                      View Resume
                    </a>
                  ) : (
                    'No Resume'
                  )}
                </div>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Upload New Resume</Form.Label>
                <Form.Control
                  type="file"
                  name="resume"
                  accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFileChange(e, 'resume')}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Member ID</Form.Label>
                <Form.Control
                  type="text"
                  name="memberId"
                  value={editMember.memberId}
                  onChange={handleChange}
                  readOnly
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  name="fullName"
                  value={editMember.fullName}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Mobile</Form.Label>
                <Form.Control
                  type="tel"
                  name="mobile"
                  value={editMember.mobile}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={editMember.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Aadhar (Optional)</Form.Label>
                <Form.Control
                  type="text"
                  name="aadhar"
                  value={editMember.aadhar}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Reference By (Optional)</Form.Label>
                <Form.Control
                  type="text"
                  name="referenceBy"
                  value={editMember.referenceBy || ''}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Gender</Form.Label>
                <Form.Control
                  as="select"
                  name="gender"
                  value={editMember.gender}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </Form.Control>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Date of Birth</Form.Label>
                <Form.Control
                  type="date"
                  name="dateOfBirth"
                  value={editMember.dateOfBirth}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Father's Name</Form.Label>
                <Form.Control
                  type="text"
                  name="fathersName"
                  value={editMember.fathersName}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>State</Form.Label>
                <Form.Control
                  type="text"
                  name="state"
                  value={editMember.state}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>City</Form.Label>
                <Form.Control
                  type="text"
                  name="city"
                  value={editMember.city}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Pin Code</Form.Label>
                <Form.Control
                  type="text"
                  name="pinCode"
                  value={editMember.pinCode}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="address"
                  value={editMember.address}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Nationality</Form.Label>
                <Form.Control
                  as="select"
                  name="nationality"
                  value={editMember.nationality}
                  onChange={handleChange}
                  required
                >
                  <option value="India">India</option>
                  <option value="Other">Other</option>
                </Form.Control>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Qualification</Form.Label>
                <Form.Control
                  type="text"
                  name="qualification"
                  value={editMember.qualification}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Area of Operation</Form.Label>
                <Form.Control
                  type="text"
                  name="areaOfOperation"
                  value={editMember.areaOfOperation}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Experience (Optional)</Form.Label>
                <Form.Control
                  type="text"
                  name="experience"
                  value={editMember.experience || ''}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Brief About Yourself</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="briefAboutYourself"
                  value={editMember.briefAboutYourself}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <div className="text-center">
                <Button variant="primary" type="submit" className="me-2 modern-btn">
                  <i className="fas fa-check"></i> Update
                </Button>
                <Button variant="secondary" className="modern-btn" onClick={() => setShowEditModal(false)}>
                  <i className="fas fa-times"></i> Cancel
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};


/// Helper function to format date to local timezone (IST) as YYYY-MM-DD
const formatDateToLocal = (dateString: string | undefined): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  // Adjust for local timezone offset to prevent date shift
  const offset = date.getTimezoneOffset();
  const adjustedDate = new Date(date.getTime() - offset * 60 * 1000);
  return adjustedDate.toISOString().split('T')[0]; // Returns YYYY-MM-DD in local timezone
};

// Helper function to format ISO date string to DD-MM-YYYY
const formatISOToDDMMYYYY = (isoString: string | undefined): string => {
  if (!isoString) return '';
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return ''; // Check if the date is invalid
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();
  return `${day}-${month}-${year}`; // e.g., "02-05-2025"
};

const DonationList: React.FC = () => {
  const [donations, setDonations] = useState<Donation[]>([]);
  const [selectedDonation, setSelectedDonation] = useState<Donation | null>(null);
  const [editPhoto, setEditPhoto] = useState<File | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [showCertificateModal, setShowCertificateModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const recordsPerPage = 20;

  useEffect(() => {
    const fetchDonations = async () => {
      try {
        const res = await fetch(`${API_URL}/api/donations`);
        if (!res.ok) throw new Error('Failed to fetch donations');
        const data: Donation[] = await res.json();
        console.log('API Response:', data); // Debug API response
        const normalizedData = data.map((donation) => ({
          ...donation,
          dateOfBirth: formatDateToLocal(donation.dateOfBirth),
        }));
        setDonations(normalizedData);
      } catch (err) {
        console.error('Error fetching donations:', err);
      }
    };
    fetchDonations();
  }, []);

  const handleDelete = async (id: number) => {
    try {
      const res = await fetch(`${API_URL}/api/donations/${id}`, {
        method: 'DELETE',
      });
      if (!res.ok) throw new Error('Failed to delete donation');
      setDonations(donations.filter((donation) => donation.id !== id));
    } catch (err) {
      console.error('Error deleting donation:', err);
    }
  };

  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedDonation) return;

    const formDataToSend = new FormData();
    formDataToSend.append('fullName', selectedDonation.fullName);
    formDataToSend.append('mobile', selectedDonation.mobile);
    formDataToSend.append('email', selectedDonation.email);
    formDataToSend.append('dateOfBirth', selectedDonation.dateOfBirth || '');
    formDataToSend.append('country', selectedDonation.country);
    formDataToSend.append('state', selectedDonation.state);
    formDataToSend.append('city', selectedDonation.city);
    formDataToSend.append('pinCode', selectedDonation.pinCode);
    formDataToSend.append('address', selectedDonation.address);
    formDataToSend.append('panNo', selectedDonation.panNo);
    formDataToSend.append('amount', selectedDonation.amount.toString());
    formDataToSend.append('paymentMethod', selectedDonation.paymentMethod);
    formDataToSend.append('message', selectedDonation.message || '');
    formDataToSend.append('receiptNo', selectedDonation.receiptNo || '');
    formDataToSend.append('preARN', selectedDonation.preARN || '');
    formDataToSend.append('certificateNo', selectedDonation.certificateNo || '');
    if (editPhoto) {
      formDataToSend.append('photo', editPhoto);
    } else {
      formDataToSend.append('photoUrl', selectedDonation.photoUrl || '');
    }

    try {
      const res = await fetch(`${API_URL}/api/donations/${selectedDonation.id}`, {
        method: 'PUT',
        body: formDataToSend,
      });
      if (res.ok) {
        const updatedDonation = await res.json();
        const updatedDonations = donations.map((donation) =>
          donation.id === selectedDonation.id
            ? { ...donation, ...updatedDonation.donation, dateOfBirth: formatDateToLocal(updatedDonation.donation.dateOfBirth) }
            : donation
        );
        setDonations(updatedDonations);
        setSelectedDonation(null);
        setEditPhoto(null);
        setShowDetailsModal(false);

        // Fetch updated data
        const fetchRes = await fetch(`${API_URL}/api/donations`);
        if (fetchRes.ok) {
          const data = await fetchRes.json();
          const normalizedData = data.map((donation: Donation) => ({
            ...donation,
            dateOfBirth: formatDateToLocal(donation.dateOfBirth),
          }));
          setDonations(normalizedData);
        }
      } else {
        console.error('Failed to update donation:', await res.json());
      }
    } catch (err) {
      console.error('Error updating donation:', err);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (selectedDonation) {
      setSelectedDonation({ ...selectedDonation, [e.target.name]: e.target.value });
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setEditPhoto(e.target.files[0]);
    }
  };

  const handleImageClick = (photoUrl: string) => {
    setSelectedImage(`${API_URL}${photoUrl}`);
  };

  const handleDeleteImage = async (id: number) => {
    try {
      const res = await fetch(`${API_URL}/api/donations/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ photoUrl: null }),
      });
      if (res.ok) {
        setDonations(donations.map((donation) => (donation.id === id ? { ...donation, photoUrl: null } : donation)));
        setSelectedImage(null);
      }
    } catch (err) {
      console.error('Error deleting image:', err);
    }
  };

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = donations.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(donations.length / recordsPerPage);

  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  const handleViewDetails = (donation: Donation) => {
    console.log('Selected Donation:', donation); // Debug selected donation
    setSelectedDonation({
      ...donation,
      dateOfBirth: formatDateToLocal(donation.dateOfBirth),
    });
    setEditPhoto(null);
    setShowDetailsModal(true);
  };

  const numberToWords = (num: number): string => {
    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    function convertLessThanOneThousand(n: number): string {
      if (n === 0) return '';
      if (n < 10) return units[n];
      if (n < 20) return teens[n - 10];
      if (n < 100) return tens[Math.floor(n / 10)] + ' ' + units[n % 10];
      return units[Math.floor(n / 100)] + ' Hundred ' + convertLessThanOneThousand(n % 100);
    }

    if (num === 0) return 'Zero';
    let result = '';
    if (num >= 10000000) {
      result += convertLessThanOneThousand(Math.floor(num / 10000000)) + ' Crore ';
      num %= 10000000;
    }
    if (num >= 100000) {
      result += convertLessThanOneThousand(Math.floor(num / 100000)) + ' Lakh ';
      num %= 100000;
    }
    if (num >= 1000) {
      result += convertLessThanOneThousand(Math.floor(num / 1000)) + ' Thousand ';
      num %= 1000;
    }
    if (num > 0) {
      result += convertLessThanOneThousand(num);
    }
    return result.trim() + ' Only';
  };

  const generatePDF = async (elementId: string, fileName: string) => {
    try {
      const element = document.getElementById(elementId);
      if (!element) {
        console.error(`Element with ID "${elementId}" not found in the DOM.`);
        alert(`Could not generate PDF: Content not found for "${elementId}".`);
        return;
      }

      console.log(`Generating PDF for element: ${elementId}`); // Debug log

      // Ensure the entire content is captured, including scrollable areas
      const canvas = await html2canvas(element, {
        scale: 2,
        scrollX: 0,
        scrollY: -window.scrollY, // Adjust for any scroll position
        windowWidth: document.documentElement.offsetWidth,
        windowHeight: element.scrollHeight, // Capture the full height of the content
      });

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgProps = pdf.getImageProperties(imgData);
      const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

      // If content height exceeds one page, add multiple pages
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
      heightLeft -= pdfHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      pdf.save(fileName);
      console.log(`PDF generated successfully: ${fileName}`); // Debug log
    } catch (error) {
      console.error(`Error generating PDF for ${elementId}:`, error);
      alert('An error occurred while generating the PDF. Please try again.');
    }
  };

  return (
    <>
      <h2 className="dashboard-title text-center mb-5">Donation List</h2>
      <Table striped bordered hover responsive className="modern-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Photo</th>
            <th>Full Name</th>
            <th>Mobile</th>
            <th>Email</th>
            <th>Amount</th>
            <th>Payment Method</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentRecords.map((donation) => (
            <tr key={donation.id}>
              <td>{donation.id}</td>
              <td>
                {donation.photoUrl ? (
                  <Image
                    src={`${API_URL}${donation.photoUrl}`}
                    alt="Donor Photo"
                    width={50}
                    height={50}
                    rounded
                    className="clickable-image"
                    onClick={() => handleImageClick(donation.photoUrl!)}
                  />
                ) : (
                  'No Photo'
                )}
              </td>
              <td>{donation.fullName}</td>
              <td>{donation.mobile}</td>
              <td>{donation.email}</td>
              <td>₹{donation.amount}</td>
              <td>{donation.paymentMethod}</td>
              <td className="action-buttons">
                <Button
                  variant="info"
                  size="sm"
                  className="me-2 modern-btn"
                  onClick={() => handleViewDetails(donation)}
                >
                  <i className="fas fa-eye"></i> View Details
                </Button>
                <Button
                  variant="warning"
                  size="sm"
                  className="me-2 modern-btn"
                  onClick={() => handleViewDetails(donation)}
                >
                  <i className="fas fa-edit"></i> Edit
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  className="modern-btn"
                  onClick={() => handleDelete(donation.id)}
                >
                  <i className="fas fa-trash-alt"></i> Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Pagination className="justify-content-center mt-4">
        {Array.from({ length: totalPages }, (_, index) => (
          <Pagination.Item
            key={index + 1}
            active={index + 1 === currentPage}
            onClick={() => paginate(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}
      </Pagination>

      <Modal show={showDetailsModal} onHide={() => { setShowDetailsModal(false); setSelectedDonation(null); }} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{selectedDonation ? `Donation Details - ID: ${selectedDonation.id}` : 'Donation Details'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedDonation && (
            <>
              {!selectedDonation.dateOfBirth && (
                <Alert variant="warning">Date of Birth not provided for this donor.</Alert>
              )}
              <Form onSubmit={handleUpdate}>
                <Form.Group className="mb-3">
                  <Form.Label>Current Photo</Form.Label>
                  <div>
                    {selectedDonation.photoUrl ? (
                      <Image
                        src={`${API_URL}${selectedDonation.photoUrl}`}
                        alt="Current Photo"
                        width={100}
                        height={100}
                        rounded
                        className="clickable-image"
                        onClick={() => handleImageClick(selectedDonation.photoUrl!)}
                      />
                    ) : (
                      'No Photo'
                    )}
                  </div>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Upload New Photo</Form.Label>
                  <Form.Control
                    type="file"
                    name="photo"
                    accept="image/*"
                    onChange={handleFileChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>ID</Form.Label>
                  <Form.Control
                    type="text"
                    name="id"
                    value={selectedDonation.id}
                    disabled
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="fullName"
                    value={selectedDonation.fullName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Mobile</Form.Label>
                  <Form.Control
                    type="text"
                    name="mobile"
                    value={selectedDonation.mobile}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={selectedDonation.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3 date-of-birth-group">
                  <Form.Label>Date of Birth</Form.Label>
                  <Form.Control
                    type="date"
                    name="dateOfBirth"
                    value={selectedDonation.dateOfBirth || ''}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Country</Form.Label>
                  <Form.Control
                    type="text"
                    name="country"
                    value={selectedDonation.country}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>State</Form.Label>
                  <Form.Control
                    type="text"
                    name="state"
                    value={selectedDonation.state}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    type="text"
                    name="city"
                    value={selectedDonation.city}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Pin Code</Form.Label>
                  <Form.Control
                    type="text"
                    name="pinCode"
                    value={selectedDonation.pinCode}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="address"
                    value={selectedDonation.address}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>PAN No</Form.Label>
                  <Form.Control
                    type="text"
                    name="panNo"
                    value={selectedDonation.panNo}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Amount</Form.Label>
                  <Form.Control
                    type="number"
                    name="amount"
                    value={selectedDonation.amount}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Payment Method</Form.Label>
                  <Form.Control
                    type="text"
                    name="paymentMethod"
                    value={selectedDonation.paymentMethod}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="message"
                    value={selectedDonation.message || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Created At</Form.Label>
                  <Form.Control
                    type="text"
                    name="createdAt"
                    value={formatISOToDDMMYYYY(selectedDonation.createdAt) || ''}
                    disabled
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Receipt No</Form.Label>
                  <Form.Control
                    type="text"
                    name="receiptNo"
                    value={selectedDonation.receiptNo || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Pre-ARN</Form.Label>
                  <Form.Control
                    type="text"
                    name="preARN"
                    value={selectedDonation.preARN || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Certificate No</Form.Label>
                  <Form.Control
                    type="text"
                    name="certificateNo"
                    value={selectedDonation.certificateNo || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
                <div className="text-center">
                  <Button
                    variant="success"
                    className="me-2 modern-btn"
                    onClick={() => setShowReceiptModal(true)}
                    disabled={!selectedDonation.receiptNo}
                  >
                    <i className="fas fa-receipt"></i> Generate Receipt
                  </Button>
                  <Button
                    variant="info"
                    className="me-2 modern-btn"
                    onClick={() => setShowCertificateModal(true)}
                    disabled={!selectedDonation.certificateNo}
                  >
                    <i className="fas fa-certificate"></i> Generate Certificate
                  </Button>
                  <Button variant="primary" type="submit" className="me-2 modern-btn">
                    <i className="fas fa-check"></i> Save Changes
                  </Button>
                  <Button
                    variant="secondary"
                    className="modern-btn"
                    onClick={() => {
                      setShowDetailsModal(false);
                      setSelectedDonation(null);
                    }}
                  >
                    <i className="fas fa-times"></i> Close
                  </Button>
                </div>
              </Form>
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={showReceiptModal} onHide={() => setShowReceiptModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Donation Receipt - {selectedDonation?.receiptNo}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedDonation && (
            <div id="receipt-content" className="receipt-container p-4">
                           <div className="row align-items-center mb-3" style={{ fontFamily: "'Segoe UI', sans-serif", fontSize: '14px' }}>
  <div className="col-md-12 text-center">
    <Image 
      src={Imagedonatelogo} 
      alt="Srisailam Foundation Logo" 
      
      className="mb-2"
    />
  </div>
 
  <hr  />
</div>


              <h4 className="text-center mb-4 fw-bold">DONATION RECEIPT</h4>

              <div className="receipt-details">
                <p><strong>Receipt No.:</strong> {selectedDonation.receiptNo}</p>
                <p><strong>Pre-Acknowledgement Reference Number (Pre-ARN):</strong> {selectedDonation.preARN}</p>
                <p><strong>Date:</strong> {formatISOToDDMMYYYY(selectedDonation.createdAt)}</p>
                <p><strong>Received with thanks from:</strong> {selectedDonation.fullName}</p>
                <p><strong>Address:</strong> {selectedDonation.address}</p>
                <p><strong>PAN of Donor:</strong> {selectedDonation.panNo}</p>
                <p>
                  <strong>a sum of Rs.</strong> {selectedDonation.amount} (Rupees {numberToWords(selectedDonation.amount)})
                </p>
                <p><strong>by way of:</strong> {selectedDonation.paymentMethod}</p>
                <p><strong>towards donation to our organization.</strong></p>
                <p>This donation is eligible for deduction under Section 80G of the Income Tax Act, 1961.</p>
                <div className="mt-4">
                  <p><strong>80G URN:</strong> ABPCS2866RF20251</p>
                  <p><strong>Date of Approval:</strong> 19.04.2025</p>
                  <p><strong>Validity:</strong> Valid till 19.04.2028</p>
                  <p><strong>PAN of NGO:</strong> ABPCS2866R</p>
                </div>

                <div className="mt-2 text-center " style={{float:'right'}}>
                  <div className="ac">
                  <p>For SRISAILAM FOUNDATION</p>
                  <Image
                    src={Imagedonatelogosign}
                    alt="Signature and Seal"
                    width={200}
                    height={100}
                    className="mt-2 "
                  />
                  <p className="mt-2">Authorized Signatory</p>
                  </div>
                  
                
             

             
               </div>
            </div>
            <p className="fst-italic text-center"style={{paddingTop:'200px'}}>Thank you for your generous support!</p>
          
            </div>
            
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowReceiptModal(false)}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => generatePDF('receipt-content', `Receipt_${selectedDonation?.receiptNo}.pdf`)}
          >
            Download PDF
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showCertificateModal} onHide={() => setShowCertificateModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Donation Certificate - {selectedDonation?.certificateNo}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedDonation && (
            <div id="certificate-content" className="certificate-container p-4">
                           <div className="row align-items-center mb-3" style={{ fontFamily: "'Segoe UI', sans-serif", fontSize: '14px' }}>
  <div className="col-md-12 text-center">
    <Image 
      src={Imagedonatelogo} 
      alt="Srisailam Foundation Logo" 
      
      className="mb-2"
    />
  </div>
 
  <hr  />
</div>

              <h4 className="text-center mb-2 fw-bold">DONATION CERTIFICATE</h4>

              <div className="certificate-details">
                <p><strong>Certificate No.:</strong> {selectedDonation.certificateNo}</p>
                <p><strong>Date:</strong> {formatISOToDDMMYYYY(selectedDonation.createdAt)}</p>
                <p><strong>Pre-Acknowledgement Reference Number (Pre-ARN):</strong> {selectedDonation.preARN}</p>
                <p><strong>Name of Donee Organization:</strong> SRISAILAM FOUNDATION</p>
                <p><strong>PAN of Donee Organization:</strong> ABPCS2866R</p>
                <p><strong>80G Registration Number:</strong> ABPCS2866RF20251 / Validity Date - 19.04.2028</p>
                <h5 className="mt-2"><b>Details of Donor:</b></h5>
                <p><strong>Name:</strong> {selectedDonation.fullName}</p>
                <p><strong>Address:</strong> {selectedDonation.address}</p>
                <p><strong>PAN:</strong> {selectedDonation.panNo}</p>
                <p><strong>Contact:</strong> {selectedDonation.mobile}</p>
                <h5 className="mt-2 "><b>Details of Donation:</b></h5>
                <p><strong>Mode of Receipt:</strong> {selectedDonation.paymentMethod}</p>
                <p><strong>Amount:</strong> ₹{selectedDonation.amount}</p>
                <p><strong>Date of Receipt:</strong> {formatISOToDDMMYYYY(selectedDonation.createdAt)}</p>
                <p className="mt-2">
                  <strong>Declaration:</strong> We hereby certify that the above donation has been received and will be utilized for charitable purposes. The donation qualifies for deduction under Section 80G of the Income Tax Act, 1961.
                </p>
                <div className="mt-2 text-center " style={{float:'right'}}>
                  <p>For SRISAILAM FOUNDATION</p>
                  <Image
                    src={Imagedonatelogosign}
                    alt="Signature and Seal"
                    width={200}
                    height={100}
                    className=""
                  />
                  <p className="">Authorized Signatory</p>
                </div>
                <div className="mt-1" style={{paddingTop:'150px'}}>
                  <p><strong>Important Note to Donor:</strong></p>
                  <ul>
                    <li>Keep this certificate safe.</li>
                    <li>Quote this certificate while claiming deduction under Section 80G in your ITR.</li>
                    <li>Ensure that your PAN is correctly mentioned.</li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCertificateModal(false)}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => generatePDF('certificate-content', `Certificate_${selectedDonation?.certificateNo}.pdf`)}
          >
            Download PDF
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={selectedImage !== null} onHide={() => setSelectedImage(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>View Image</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {selectedImage && <Image src={selectedImage} alt="Selected" fluid style={{ maxHeight: '400px' }} />}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              const donation = donations.find((d) => `${API_URL}${d.photoUrl}` === selectedImage);
              if (donation) handleDeleteImage(donation.id);
            }}
          >
            Delete Image
          </Button>
          <Button variant="secondary" onClick={() => setSelectedImage(null)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
// ... (rest of the file remains unchanged)
// ... (rest of the file remains unchanged)
// वॉलंटियर लिस्ट
// ... (previous imports and interfaces remain unchanged)

const VolunteerList: React.FC = () => {
  const [volunteers, setVolunteers] = useState<Volunteer[]>([]);
  const [editVolunteer, setEditVolunteer] = useState<Volunteer | null>(null);
  const [editPhoto, setEditPhoto] = useState<File | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const recordsPerPage = 20;

  useEffect(() => {
    const fetchVolunteers = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_URL}/api/volunteers`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error('Failed to fetch volunteers');
        const data: any[] = await res.json(); // Use 'any' temporarily to handle potential JSON string for skills
        const parsedVolunteers = data.map((volunteer) => ({
          ...volunteer,
          skills: typeof volunteer.skills === 'string' ? JSON.parse(volunteer.skills) : volunteer.skills || [],
        }));
        setVolunteers(parsedVolunteers as Volunteer[]);
      } catch (err) {
        console.error('Error fetching volunteers:', err);
      }
    };
    fetchVolunteers();
  }, []);

  const handleDelete = async (id: number) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/api/volunteers/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error('Failed to delete volunteer');
      setVolunteers(volunteers.filter((volunteer) => volunteer.id !== id));
    } catch (err) {
      console.error('Error deleting volunteer:', err);
    }
  };

  const handleEdit = (volunteer: Volunteer) => {
    setEditVolunteer(volunteer);
    setEditPhoto(null);
    setShowEditModal(true);
  };

  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!editVolunteer) return;

    const formDataToSend = new FormData();
    formDataToSend.append('fullName', editVolunteer.fullName);
    formDataToSend.append('mobile', editVolunteer.mobile);
    formDataToSend.append('email', editVolunteer.email);
    formDataToSend.append('aadhar', editVolunteer.aadhar);
    formDataToSend.append('gender', editVolunteer.gender);
    formDataToSend.append('dateOfBirth', editVolunteer.dateOfBirth);
    formDataToSend.append('state', editVolunteer.state);
    formDataToSend.append('city', editVolunteer.city);
    formDataToSend.append('pinCode', editVolunteer.pinCode);
    formDataToSend.append('address', editVolunteer.address);
    formDataToSend.append('skills', JSON.stringify(editVolunteer.skills));
    formDataToSend.append('otherSkill', editVolunteer.otherSkill);
    formDataToSend.append('availability', editVolunteer.availability);
    formDataToSend.append('volunteeringArea', editVolunteer.volunteeringArea);
    formDataToSend.append('previousExperience', editVolunteer.previousExperience);
    formDataToSend.append('experienceDetails', editVolunteer.experienceDetails);
    if (editPhoto) {
      formDataToSend.append('photo', editPhoto);
    } else {
      formDataToSend.append('photoUrl', editVolunteer.photoUrl || '');
    }

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/api/volunteers/${editVolunteer.id}`, {
        method: 'PUT',
        headers: { Authorization: `Bearer ${token}` },
        body: formDataToSend,
      });

      if (res.ok) {
        const updatedVolunteer = await res.json();
        setVolunteers(
          volunteers.map((volunteer) =>
            volunteer.id === editVolunteer.id ? { ...volunteer, ...editVolunteer, photoUrl: updatedVolunteer.photoUrl || volunteer.photoUrl } : volunteer
          )
        );
        setEditVolunteer(null);
        setEditPhoto(null);
        setShowEditModal(false);
      } else {
        console.error('Failed to update volunteer:', await res.json());
      }
    } catch (err) {
      console.error('Error updating volunteer:', err);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    if (editVolunteer) {
      const { name, value } = e.target;
      setEditVolunteer({ ...editVolunteer, [name]: value });
    }
  };

  const handleMultiSelectChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    if (editVolunteer && e.target instanceof HTMLSelectElement && e.target.multiple) {
      const options = e.target.selectedOptions;
      const values = Array.from(options, (option) => option.value);
      setEditVolunteer({ ...editVolunteer, skills: values });
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setEditPhoto(e.target.files[0]);
    }
  };

  const handleImageClick = (photoUrl: string) => {
    setSelectedImage(photoUrl);
    setShowModal(true);
  };

  const handleDeleteImage = async (id: number) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/api/volunteers/${id}`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ photoUrl: null }),
      });

      if (res.ok) {
        setVolunteers(
          volunteers.map((volunteer) =>
            volunteer.id === id ? { ...volunteer, photoUrl: null } : volunteer
          )
        );
        setShowModal(false);
      }
    } catch (err) {
      console.error('Error deleting image:', err);
    }
  };

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = volunteers.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(volunteers.length / recordsPerPage);

  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  return (
    <>
      <h2 className="dashboard-title text-center mb-5">Volunteer List</h2>
      <Table striped bordered hover responsive className="modern-table">
        <thead>
          <tr>
            <th>Photo</th>
            
            <th>Full Name</th>
            <th>Mobile</th>
            <th>Email</th>
            <th>Address</th>
            <th>Adhar Details</th>
            <th>Date of Birth</th>
            <th>State</th>
            <th>City</th>
            <th>Pin Code</th>
            <th>Previous Volunteer Experience </th>
            <th>Experience Details</th>
            <th>Skills</th>
            <th>Availability</th>
            <th>Volunteering Area</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentRecords.map((volunteer) => (
            <tr key={volunteer.id}>
              <td>
                {volunteer.photoUrl ? (
                  <Image
                    src={`${API_URL}${volunteer.photoUrl}`}
                    alt="Volunteer Photo"
                    width={50}
                    height={50}
                    rounded
                    className="clickable-image"
                    onClick={() => handleImageClick(`${API_URL}${volunteer.photoUrl}`)}
                  />
                ) : (
                  'No Photo'
                )}
              </td>
             
              <td>{volunteer.fullName}</td>
              <td>{volunteer.mobile}</td>
              <td>{volunteer.email}</td>
              <td>{volunteer.address}</td>
              <td>{volunteer.aadhar}</td>
              <td>{volunteer.dateOfBirth}</td>
              <td>{volunteer.state}</td>
              <td>{volunteer.city}</td>
              <td>{volunteer.pinCode}</td>
              <td>{volunteer.previousExperience}</td>
              <td>{volunteer.experienceDetails || 'N/A'}</td>
              <td>{volunteer.skills.join(', ') || 'N/A'}</td>
              <td>{volunteer.availability || 'N/A'}</td>
              <td>{volunteer.volunteeringArea || 'N/A'}</td>
              <td className="action-buttons">
                <Button
                  variant="warning"
                  size="sm"
                  className="me-2 modern-btn"
                  onClick={() => handleEdit(volunteer)}
                >
                  <i className="fas fa-edit"></i> Edit
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  className="modern-btn"
                  onClick={() => handleDelete(volunteer.id)}
                >
                  <i className="fas fa-trash-alt"></i> Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Pagination className="justify-content-center mt-4">
        {Array.from({ length: totalPages }, (_, index) => (
          <Pagination.Item
            key={index + 1}
            active={index + 1 === currentPage}
            onClick={() => paginate(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}
      </Pagination>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>View Image</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {selectedImage && (
            <Image src={selectedImage} alt="Selected" fluid style={{ maxHeight: '400px' }} />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              const volunteer = volunteers.find((v) => `${API_URL}${v.photoUrl}` === selectedImage);
              if (volunteer) handleDeleteImage(volunteer.id);
            }}
          >
            Delete Image
          </Button>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {editVolunteer && (
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Edit Volunteer</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleUpdate}>
              <Form.Group className="mb-3">
                <Form.Label>Current Photo</Form.Label>
                <div>
                  {editVolunteer.photoUrl ? (
                    <Image src={`${API_URL}${editVolunteer.photoUrl}`} alt="Current Photo" width={100} height={100} rounded />
                  ) : (
                    'No Photo'
                  )}
                </div>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Upload New Photo</Form.Label>
                <Form.Control
                  type="file"
                  name="photo"
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  name="fullName"
                  value={editVolunteer.fullName}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Mobile</Form.Label>
                <Form.Control
                  type="tel"
                  name="mobile"
                  value={editVolunteer.mobile}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={editVolunteer.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Aadhar (Optional)</Form.Label>
                <Form.Control
                  type="text"
                  name="aadhar"
                  value={editVolunteer.aadhar}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Gender</Form.Label>
                <Form.Control
                  as="select"
                  name="gender"
                  value={editVolunteer.gender}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </Form.Control>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Date of Birth</Form.Label>
                <Form.Control
                  type="date"
                  name="dateOfBirth"
                  value={editVolunteer.dateOfBirth}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>State</Form.Label>
                <Form.Control
                  type="text"
                  name="state"
                  value={editVolunteer.state}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>City</Form.Label>
                <Form.Control
                  type="text"
                  name="city"
                  value={editVolunteer.city}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Pin Code</Form.Label>
                <Form.Control
                  type="text"
                  name="pinCode"
                  value={editVolunteer.pinCode}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  as="textarea"
                  name="address"
                  value={editVolunteer.address}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Skills & Expertise</Form.Label>
                <Form.Control
                  as="select"
                  name="skills"
                  value={editVolunteer.skills} // Note: This might need adjustment
                  onChange={handleMultiSelectChange}
                  multiple
                  required
                >
                  <option value="Technical">Technical</option>
                  <option value="Teaching">Teaching</option>
                  <option value="IT">IT</option>
                  <option value="Others">Others</option>
                </Form.Control>
                {editVolunteer.skills.includes('Others') && (
                  <Form.Control
                    type="text"
                    name="otherSkill"
                    value={editVolunteer.otherSkill}
                    onChange={handleChange}
                    placeholder="Specify other skill"
                    className="mt-2"
                  />
                )}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Availability</Form.Label>
                <Form.Control
                  as="select"
                  name="availability"
                  value={editVolunteer.availability}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Availability</option>
                  <option value="DAY">Day</option>
                  <option value="Hours">Hours</option>
                  <option value="Weekend">Weekend</option>
                </Form.Control>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Preferred Volunteering Area</Form.Label>
                <Form.Control
                  as="select"
                  name="volunteeringArea"
                  value={editVolunteer.volunteeringArea}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Area</option>
                  <option value="Education">Education</option>
                  <option value="Women Empowerment">Women Empowerment</option>
                  <option value="Environment">Environment</option>
                  <option value="Health">Health</option>
                  <option value="Livelihood">Livelihood</option>
                  <option value="Fundraising">Fundraising</option>
                  <option value="Administrator">Administrator</option>
                </Form.Control>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Previous Volunteer Experience</Form.Label>
                <Form.Control
                  as="select"
                  name="previousExperience"
                  value={editVolunteer.previousExperience}
                  onChange={handleChange}
                  required
                >
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Form.Control>
                {editVolunteer.previousExperience === 'Yes' && (
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="experienceDetails"
                    value={editVolunteer.experienceDetails}
                    onChange={handleChange}
                    placeholder="Provide details"
                    className="mt-2"
                  />
                )}
              </Form.Group>
              <div className="text-center">
                <Button variant="primary" type="submit" className="me-2 modern-btn">
                  <i className="fas fa-check"></i> Update
                </Button>
                <Button variant="secondary" className="modern-btn" onClick={() => setShowEditModal(false)}>
                  <i className="fas fa-times"></i> Cancel
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

// ... (rest of the file remains unchanged)

// Add Blog
const AddBlog: React.FC = () => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
  });
  const [image, setImage] = useState<File | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setImage(e.target.files[0]);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const formDataToSend = new FormData();
    formDataToSend.append('title', formData.title);
    formDataToSend.append('description', formData.description);
    if (image) {
      formDataToSend.append('image', image);
    }

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        alert('You need to be logged in to add a blog.');
        return;
      }

      const res = await fetch(`${API_URL}/api/blogs`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formDataToSend,
      });

      const data = await res.json();
      if (res.ok) {
        alert('Blog added successfully!');
        setFormData({ title: '', description: '' });
        setImage(null);
      } else {
        alert(`Error adding blog: ${data.message || 'Unknown error'} - ${data.error || ''}`);
      }
    } catch (err) {
      console.error('Error adding blog:', err);
      alert(`Error adding blog: ${(err as Error).message || 'Network error'}`);
    }
  };

  return (
    <>
      <h2 className="dashboard-title text-center mb-5">Add New Blog</h2>
      <div className="modern-form">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter blog title"
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Enter blog description"
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Upload Image</Form.Label>
            <Form.Control
              type="file"
              name="image"
              accept="image/*"
              onChange={handleFileChange}
              required
            />
          </Form.Group>
          <div className="text-center">
            <Button variant="primary" type="submit" className="modern-btn">
              Add Blog
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
};

// Blog List Component
const BlogList: React.FC = () => {
  const [blogs, setBlogs] = useState<Blog[]>([]);
  const [editBlog, setEditBlog] = useState<Blog | null>(null);
  const [formData, setFormData] = useState({ title: '', description: '', imageUrl: '' });
  const [image, setImage] = useState<File | null>(null);
  const [showEditModal, setShowEditModal] = useState(false); // State for edit modal
  const [showImageModal, setShowImageModal] = useState(false); // State for image modal
  const [selectedImage, setSelectedImage] = useState<string | null>(null); // State for selected image
  const navigate = useNavigate();

  // Fetch blogs on component mount
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/login');
          return;
        }

        const res = await fetch(`${API_URL}/api/blogs`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!res.ok) throw new Error('Failed to fetch blogs');
        const data: Blog[] = await res.json();
        setBlogs(data);
      } catch (err) {
        console.error('Error fetching blogs:', err);
        alert(`Error fetching blogs: ${(err as Error).message || 'Network error'}`);
      }
    };
    fetchBlogs();
  }, [navigate]);

  // Handle Edit button click
  const handleEdit = (blog: Blog) => {
    setEditBlog(blog);
    setFormData({
      title: blog.title,
      description: blog.description,
      imageUrl: blog.imageUrl || '',
    });
    setImage(null);
    setShowEditModal(true); // Open the edit modal
  };

  // Handle form change for edit
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setImage(e.target.files[0]);
    }
  };

  // Handle Edit form submission
  const handleEditSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!editBlog) return;

    const formDataToSend = new FormData();
    formDataToSend.append('title', formData.title);
    formDataToSend.append('description', formData.description);
    formDataToSend.append('imageUrl', formData.imageUrl); // Send existing imageUrl
    if (image) {
      formDataToSend.append('image', image); // Send new image if uploaded
    }

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/api/blogs/${editBlog.id}`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formDataToSend,
      });

      const data = await res.json();
      if (res.ok) {
        alert('Blog updated successfully!');
        setBlogs(blogs.map((blog) => (blog.id === editBlog.id ? { ...blog, ...formData, imageUrl: data.imageUrl || formData.imageUrl } : blog)));
        setEditBlog(null);
        setFormData({ title: '', description: '', imageUrl: '' });
        setImage(null);
        setShowEditModal(false); // Close the modal
      } else {
        alert(`Error updating blog: ${data.message || 'Unknown error'}`);
      }
    } catch (err) {
      console.error('Error updating blog:', err);
      alert(`Error updating blog: ${(err as Error).message || 'Network error'}`);
    }
  };

  // Handle Delete button click
  const handleDelete = async (id: number) => {
    if (!window.confirm('Are you sure you want to delete this blog?')) return;

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/api/blogs/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();
      if (res.ok) {
        alert('Blog deleted successfully!');
        setBlogs(blogs.filter((blog) => blog.id !== id));
      } else {
        alert(`Error deleting blog: ${data.message || 'Unknown error'}`);
      }
    } catch (err) {
      console.error('Error deleting blog:', err);
      alert(`Error deleting blog: ${(err as Error).message || 'Network error'}`);
    }
  };

  // Handle Image click to open modal
  const handleImageClick = (imageUrl: string) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };

  // Handle Delete Image
  const handleDeleteImage = async (id: number) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/api/blogs/${id}`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ imageUrl: null }), // Set imageUrl to null
      });

      if (res.ok) {
        setBlogs(
          blogs.map((blog) =>
            blog.id === id ? { ...blog, imageUrl: null } : blog
          )
        );
        setShowImageModal(false); // Close the modal
      } else {
        alert('Failed to delete image');
      }
    } catch (err) {
      console.error('Error deleting image:', err);
      alert(`Error deleting image: ${(err as Error).message || 'Network error'}`);
    }
  };

  return (
    <>
      <h2 className="dashboard-title text-center mb-5">Manage Blogs</h2>
      <Table striped bordered hover responsive className="modern-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Description</th>
            <th>Image</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {blogs.map((blog) => (
            <tr key={blog.id}>
              <td>{blog.id}</td>
              <td>{blog.title}</td>
              <td>{blog.description.substring(0, 50)}...</td>
              <td>
                {blog.imageUrl ? (
                  <Image
                    src={`${API_URL}${blog.imageUrl}`}
                    alt={blog.title}
                    width={50}
                    height={50}
                    rounded
                    className="clickable-image"
                    onClick={() => handleImageClick(`${API_URL}${blog.imageUrl}`)}
                  />
                ) : (
                  'No Image'
                )}
              </td>
              <td className="action-buttons">
                <Button
                  variant="warning"
                  size="sm"
                  className="me-2 modern-btn"
                  onClick={() => handleEdit(blog)}
                >
                  <i className="fas fa-edit"></i> Edit
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  className="modern-btn"
                  onClick={() => handleDelete(blog.id)}
                >
                  <i className="fas fa-trash-alt"></i> Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Image Modal */}
      <Modal show={showImageModal} onHide={() => setShowImageModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>View Image</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {selectedImage && (
            <Image src={selectedImage} alt="Selected" fluid style={{ maxHeight: '400px' }} />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              const blog = blogs.find((b) => `${API_URL}${b.imageUrl}` === selectedImage);
              if (blog) handleDeleteImage(blog.id);
            }}
          >
            Delete Image
          </Button>
          <Button variant="secondary" onClick={() => setShowImageModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Blog Modal */}
      {editBlog && (
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Edit Blog</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleEditSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Current Image</Form.Label>
                <div>
                  {formData.imageUrl ? (
                    <Image src={`${API_URL}${formData.imageUrl}`} alt="Current" width={100} height={100} rounded />
                  ) : (
                    'No Image'
                  )}
                </div>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Upload New Image (Optional)</Form.Label>
                <Form.Control
                  type="file"
                  name="image"
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  placeholder="Enter blog title"
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Enter blog description"
                  required
                />
              </Form.Group>
              <div className="text-center">
                <Button variant="primary" type="submit" className="me-2 modern-btn">
                  <i className="fas fa-check"></i> Update
                </Button>
                <Button variant="secondary" className="modern-btn" onClick={() => setShowEditModal(false)}>
                  <i className="fas fa-times"></i> Cancel
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};
// Change Password
const ChangePassword: React.FC = () => {
  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.newPassword !== formData.confirmPassword) {
      alert('New password and confirm password do not match.');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/api/auth/change-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          oldPassword: formData.oldPassword,
          newPassword: formData.newPassword,
        }),
      });
      const data = await res.json();
      if (res.ok) {
        alert('Password changed successfully!');
        setFormData({ oldPassword: '', newPassword: '', confirmPassword: '' });
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error('Error changing password:', err);
      alert('Error changing password. Please try again.');
    }
  };

  return (
    <>
      <h2 className="dashboard-title text-center mb-5">Change Password</h2>
      <div className="modern-form">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Old Password</Form.Label>
            <Form.Control
              type="password"
              name="oldPassword"
              value={formData.oldPassword}
              onChange={handleChange}
              placeholder="Enter old password"
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              name="newPassword"
              value={formData.newPassword}
              onChange={handleChange}
              placeholder="Enter new password"
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Confirm New Password</Form.Label>
            <Form.Control
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="Confirm new password"
              required
            />
          </Form.Group>
          <div className="text-center">
            <Button variant="primary" type="submit" className="modern-btn">
              Change Password
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
};

export default Dashboard;